// extracted by mini-css-extract-plugin
export default {"selectionGroup":"h2hiq_EfL9_landings"};